import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Statistic, Skeleton } from 'antd';
import SubscriptionsColumnChart from 'pages/reports/subscriptions-chart';
import PlansPieChart from 'pages/reports/plans-chart';
import UsersList from 'pages/reports/users-list';

import { getGeneralStatistics } from 'api-services/reporting';
import useDecodeToken from 'hooks/use-decode-token';
import { useNavigate } from 'react-router';

const ReportPage = () => {
  const navigate = useNavigate();
  const { role } = useDecodeToken();

  const [generalStats, setGeneralStats] = useState(null);
  const [skeleton, setSkeleton] = useState(true);

  const statsMap = [
    {
      key: 'totalSubscriptions',
      title: 'Total Subscriptions',
    },
    {
      key: 'premiumSubscribers',
      title: 'Premium Subscribers',
    },
    {
      key: 'totalChatbots',
      title: 'Total Chatbots',
    },
    {
      key: 'chatbotInteractions',
      title: 'Chatbot Interactions',
    },
  ];

  useEffect(() => {
    const fetchGeneralStatistics = async () => {
      setSkeleton(true);
      const response = await getGeneralStatistics();
      if (response.status === 200) {
        setGeneralStats(response.data);
      }
      setSkeleton(false);
    };

    if(role !==undefined && role !== 1){
      navigate('/chatbots');
    }

    fetchGeneralStatistics();
  }, [role]);


  return (
    <div>
      <Row gutter={24} style={{ padding: '10px 0px 10px 0px' }}>
        {
          statsMap.map((stat) => (
            <Col span={6} key={stat.key}>
              <Card>
                {skeleton ? <Skeleton active /> : <Statistic title={stat.title} value={generalStats?generalStats[stat.key]:0} />}
              </Card>
            </Col>
          ))
        }
      </Row>

      <Row gutter={24} style={{ padding: '10px 0px 10px 0px' }}>
        <Col span={24}>
          <Card>
            <UsersList />
          </Card>
        </Col>
      </Row>

      <Row gutter={24} style={{ padding: '10px 0px 10px 0px' }}>
        <Col span={16}>
          <Card>
            <h2>Subscriptions Sold (Last 6 Months)</h2>
            <SubscriptionsColumnChart />
          </Card>
        </Col>

        <Col span={8}>
          <Card>
            <h2>Hottest Selling Plan</h2>
            <PlansPieChart />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ReportPage;
